module.exports = __webpack_public_path__ + "static/Nelson Su.564eaab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Nelson Su.jpg
// module id = 1226
// module chunks = 6166952557895